import { IMPROVE_SCORE_FLOW, type ImproveScoreFlow } from './const';
import { isSectionRecomposeResult } from './generationResult';
import type { RecomposeRequest } from './types';

export interface ImproveScoreRecovery {
  recomposeRequestId?: string;
  flow?: ImproveScoreFlow;
  eligibleToRetry?: boolean;
  lowerScoringAvailable?: boolean;
  retrying?: boolean;
  promoting?: boolean;
  attempt?: number;
}

export type PendingImproveScoreRecovery<T extends ImproveScoreRecovery = ImproveScoreRecovery> =
  T & {
    recomposeRequestId: string;
  };

export const buildImproveScoreRecovery = (result: RecomposeRequest): ImproveScoreRecovery => ({
  recomposeRequestId: String(result.id),
  flow: isSectionRecomposeResult(result)
    ? IMPROVE_SCORE_FLOW.sections
    : IMPROVE_SCORE_FLOW.variation,
  eligibleToRetry: Boolean(result.isEligibleToRetry),
  lowerScoringAvailable: Boolean(result.lowerScoringResultsAvailable),
  retrying: false,
  promoting: false,
  attempt: 0,
});

export const isRecoveryActionable = <T extends ImproveScoreRecovery>(
  recovery?: T | null
): recovery is PendingImproveScoreRecovery<T> =>
  Boolean(recovery?.recomposeRequestId && !recovery.retrying && !recovery.promoting);

// the sections flow returns the section's own original variation alongside the produced ones, and
// only the produced ones point back at the variation they improve
export const countProducedVariations = (result: RecomposeRequest): number =>
  (result.variations || []).filter((variation) => variation.originalVariationId).length;
